import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { createPriceAvailabilityRequest } from '../../../common/api/clients/priceAvailability.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const usePriceAvailabilityCreate = () => {
    const queryClient = useQueryClient();
    const { addToast, addErrorToast } = useToasts();

    return useMutation({
        mutationFn: createPriceAvailabilityRequest,
        onSuccess: (_, variables) => {
            addToast(translate('offer.priceAvailability.createSuccess'));
            // Invalidate PAI queries for this offer
            queryClient.invalidateQueries({
                queryKey: queries.priceAvailability.byOfferId(variables.offerId).queryKey,
            });
        },
        onError: () => {
            addErrorToast(translate('offer.priceAvailability.createError'));
        },
    });
};
